import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

@Component({
  selector: "bca-receipt-footer",
  templateUrl: "receipt-footer.component.html",
  styleUrls: ["receipt-footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptFooterComponent {
  @Input()
  totalProductCount: number;
  @Input()
  totalReceiptPrice: number;
  @Output()
  open = new EventEmitter<void>();
}
